/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Unlink_Confirm_CtaInputs */

const he_account_delivery_unlink_confirm_cta = /** @type {(inputs: Account_Delivery_Unlink_Confirm_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ניתוק`)
};

const en_account_delivery_unlink_confirm_cta = /** @type {(inputs: Account_Delivery_Unlink_Confirm_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink`)
};

/**
* | output |
* | --- |
* | "Unlink" |
*
* @param {Account_Delivery_Unlink_Confirm_CtaInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_unlink_confirm_cta = /** @type {((inputs?: Account_Delivery_Unlink_Confirm_CtaInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Unlink_Confirm_CtaInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_unlink_confirm_cta(inputs)
	return en_account_delivery_unlink_confirm_cta(inputs)
});